var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"align":"center","demoted-icon":_vm.field.type,"is-sticky":_vm.isSticky,"is-demoted":_vm.isDemoted,"field":_vm.field,"filter":_vm.filter}},[_c('app-view-common-history',{attrs:{"history":_vm.history}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }